import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'
import routes from '../routes'
import { useSelector } from 'react-redux'

const AppContent = () => {
  const { navigationData } = useSelector((state) => state.adminnavigation)

  const extractPaths = (data) => {
    const paths = []
    data?.forEach((entry) => {
      if (entry.type === 'item') {
        paths.push(entry.to)
      } else if (entry.type === 'group') {
        entry.items?.forEach((item) => {
          if (item.type === 'item') {
            paths.push(item.to)
          }
        })
      }
    })
    return paths
  }

  const allowedPaths = extractPaths(navigationData)

  const isPathAllowed = (routePath) => {
    const isUsersAllAllowed = allowedPaths.includes('/users/all')
    const additionalUserPaths = ['/users/new', '/users/:id', '/users/edit/:id']

    return (
      allowedPaths.includes(routePath) ||
      (isUsersAllAllowed && additionalUserPaths.includes(routePath)) ||
      routePath === '/profile' ||
      routePath === '/dashboard'
    )
  }

  return (
    <CContainer lg>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Routes>
          {routes.map((route, idx) => {
            if (!route.element) return null
            if (isPathAllowed(route.path)) {
              return (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            }
            return null
          })}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
